<script lang="ts">
    import AdminView from './AdminView.svelte';
    import Block from './Block.svelte';

    export let props: any = null;
    export let adminView = false;
  
  </script>
  
  {#if adminView}
    <AdminView {props} />
  {:else}
    <Block {props} />
  {/if}
  